module.exports = __webpack_public_path__ + "media/images/favicon-32x32-845f3f77742de0bb8704635320d55564.png";